import { faChevronLeft } from '@fortawesome/pro-regular-svg-icons/faChevronLeft';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons/faChevronRight';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import padStart from 'lodash/padStart';
import moment, { Moment } from 'moment-timezone';
import React from 'react';
import Calendar from 'react-calendar';
import styles from './DayPicker.module.scss';

interface DayPickerProps {
    timeZone: string;
    date: Moment;
    onChange: (date: Moment) => void;
}

export const DayPicker: React.FC<DayPickerProps> = ({ timeZone, date, onChange }) => {
    const selectDate = (selectedDate: Date) => {
        const ddmmyyyy = `${padStart(selectedDate.getDate().toString(), 2, '0')}${padStart(
            (selectedDate.getMonth() + 1).toString(),
            2,
            '0'
        )}${selectedDate.getFullYear()}`;
        onChange(moment.tz(ddmmyyyy, 'DDMMYYYY', timeZone).clone());
    };

    return (
        <Calendar
            calendarType="US"
            onClickDay={selectDate}
            value={date.clone().hour(12).toDate()}
            className={styles.calendar}
            nextLabel={<FontAwesomeIcon icon={faChevronRight} />}
            prevLabel={<FontAwesomeIcon icon={faChevronLeft} />}
            prev2Label={null}
            next2Label={null}
            showNeighboringMonth={false}
            locale={'en'}
        />
    );
};

export default DayPicker;
